const endpoints = {
  GET_TAB_LISTS: {
    url: ({ courseId }) => `/v2/course/courseTabList/1668`,
    method: "GET",
  },
  GET_COURSE_OVERVIEW: {
    url: ({ courseId }) =>
      `/v2/course/student/courseDetail/${courseId}?storeEvent=true`,
    method: "GET",
  },
  GET_NEW_SERVICE_UPCOMING_CLASS: {
    url: ({ courseId }) => `/mm/v3/session/student/upcoming?courseId=${courseId}`,
    method: "GET",
  },
  GET_USER_DETAILS: {
    url: () => `/v2/users/details`,
    method: "GET",
  },
  GET_ORG_DETAILS: {
    url: () => `/v2/org/details`,
    method: "GET",
  },
  POST_LIKE_COURSE: {
    url: ({ courseId }) => `/v2/course/like/update`,
    method: "POST",
  },
  GET_ORG_DETAILS: {
    url: ({ courseId }) => `/v2/org/details`,
    method: "GET",
  },
  POST_TIGHT_ON_BUDGET_BOTTOMSHEET: {
    url: ({}) => `/v2/course/installment/alert`,
    method: "POST",
  },
  FUNNEL_TRACK_API: {
    url: () => `/v2/course/storeEvent/track`,
    method: "POST",
    params: [],
  },
  GET_INDIVIDUAL_INSTALLMENT_API: {
    url: ({ courseId, installmentId, optedAddOn = 0 }) =>
      `/v2/course/installment/info/${installmentId}?courseId=${courseId}${
        optedAddOn ? `&optedAddOn=${optedAddOn}` : ''
      }`,

    method: "GET",
  },
  UPDATE_PREFERRED_STATE_API: {
    url: () => `/v2/course/user/location/edit`,
    method: "PATCH",
  },

  GET_COURSE_FACULTY_LIST_API: {
    url: ({ courseId }) => `/v3/course/combo/courses?courseId=${courseId}`,
    method: "GET",
  },
  CAPTURE_INTEREST: {
    url: () => `/v2/course/capture/interest`,
    method: "POST",
  },
  GET_DYNAMIC_BUNDLING_COURSE_LIST_API: {
    url: ({ courseId }) => `/v3/course/dynamicBundle/get/${courseId}`,
    method: "get",
  },
  POST_ENABLE_TRIAL_COURSE: {
    url: () => `/v3/course/content/trial`,
    method: "POST",
  },
  POST_ENROLL_FREE_COURSE: {
    url: () => `/v2/course/subscribe/student/free-course`,
    method: "POST",
  },
};
export default endpoints;
